import { render, staticRenderFns } from "./cabecerabaja.vue?vue&type=template&id=04342604&"
import script from "./cabecerabaja.vue?vue&type=script&lang=js&"
export * from "./cabecerabaja.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports